import _ from 'lodash'
import stringHash from 'string-hash'

const hourMs = 60000 * 60

export const MAX_INTENSITY = 100 * 100

// prettier-ignore
export const TIME_INTENSITY_OFFSETS = [
  // SUN hourly offsets
  [
    1, 2, 3, 9, 12, 13,
    18, 18, 10, 22, 29, 23,
    23, 33, 29, 22, 24, 21,
    14, 19, 11, 14, 8, 1
  ],
  // MON hourly offsets
  [
    2, 1, 4, 8, 18, 26,
    34, 55, 55, 66, 92, 88,
    97, 95, 94, 86, 66, 66,
    34, 33, 22, 10, 7, 8
  ],
  // TUE hourly offsets
  [
    2, 6, 2, 9, 18, 22,
    33, 54, 64, 66, 87, 92,
    88, 82, 75, 66, 55, 50,
    33, 22, 18, 14, 7, 8
  ],
  // WED hourly offsets
  [
    2, 4, 2, 8, 18, 30,
    34, 54, 65, 80, 90, 97,
    65, 80, 90, 65, 56, 47,
    40, 26, 18, 4, 7, 8
  ],
  // THU hourly offsets
  [
    2, 5, 2, 12, 8, 10,
    16, 24, 65, 82, 88, 94,
    92, 80, 70, 65, 53, 47,
    44, 36, 22, 12, 7, 9
  ],
  // FRI hourly offsets
  [
    2, 1, 2, 11, 18, 17,
    22, 35, 35, 55, 55, 55,
    66, 77, 55, 44, 44, 44,
    33, 33, 29, 14, 7, 8
  ],
  // SAT hourly offsets
  [
    1, 2, 5, 8, 6, 8,
    9, 6, 9, 10, 15, 24,
    28, 22, 36, 33, 24, 10,
    11, 11, 10, 4, 3, 5
  ]
]


const getHashComputedCounterValue = (
  hash,
  prevValue = null,
  intensity,
  maxValue,
  minValue = 0
) => {
  // console.log('get counter1', maxValue)

  const minMaxDiff = maxValue - minValue
  const intensityFactor = intensity / MAX_INTENSITY
  const maxPossWithIntensity = minMaxDiff * intensityFactor

  const zeroChance =
    intensityFactor > 0.2
      ? 0
      : intensityFactor > 0.1
        ? ((hash * intensityFactor) >> 1) & 1 // ~25%
        : ((hash * intensityFactor) >> 7) & 1 // ~50% -- lower intensities should tend more to zero

  // If prev was zero the tendency to continue zero should be higher (Inverted chances)
  const valueZero = zeroChance === (prevValue === 0 ? 0 : 1)

  const baseValue = valueZero
    ? 0
    : Math.abs((hash >> maxPossWithIntensity) & (maxPossWithIntensity + 1)) *
      intensityFactor

  // Higher intensities should tend to maintain a steady value
  const deviationFromPrevFactor = intensityFactor > 0.2 ? 10 : 2
  const prevDiff = (prevValue - minValue - baseValue) / deviationFromPrevFactor

  const withPrevValWeighting =
    prevValue === null // No weighting if no previous value passed
      ? baseValue
      : baseValue + prevDiff

  return Math.round(minValue + withPrevValWeighting)
}

/**
 * Counter data is based off of a roughly weekly
 * periodicity to approximate real network traffic fluctuations
 *
 * intensity: overall scaling/weighting factor
 */

export const getMockCounterData = (
  seedString = '',
  startTime,
  endTime,
  interval,
  counterNamesToIntensity,
  maxPerHour = 10000,
  minPossible = 0,
  timestampKey = 'timestamp'
) => {
  if (
    !seedString ||
    seedString.length === 0 ||
    !startTime ||
    !endTime ||
    !interval ||
    !counterNamesToIntensity
  ) {
    console.error(
      '~~~getMockCounterData: missing required parameters',
      seedString,
      startTime,
      endTime,
      interval,
      counterNamesToIntensity
    )
    return []
  }

  // Honor a max-per-hour value, convert to interval portions
  const maxPerInterval = maxPerHour * (interval / hourMs)

  const counterNames = Object.keys(counterNamesToIntensity)

  const output = []
  const ticks = _.range(startTime, endTime, interval)

  for (let i = 0, iLen = ticks.length; i < iLen; i++) {
    const tick = ticks[i]

    // let total = 0
    const counterValues = {}
    // const prevTick = i > 0 ? output[i - 1] : null

    const tickDate = new Date(tick)
    const tickDay = tickDate.getDay() // zero-based
    const tickHour = tickDate.getHours() // zero-based
    const timeIntensity = TIME_INTENSITY_OFFSETS[tickDay][tickHour]

    const hash = stringHash(`${seedString}-${tickDate.toISOString()}`)

    for (let ii = 0, iiLen = counterNames.length; ii < iiLen; ii++) {
      const counterName = counterNames[ii]
      const counterIntensity = counterNamesToIntensity[counterName]
      const baseIntensity = timeIntensity * counterIntensity
      // FIXME this can't use any previous data or loop indexes. Only the source string and timestamp
      const prevValue = null
      // const prevValue = prevTick && prevTick.values ? prevTick.values[counterName] : null
      const maxPerCounter = maxPerInterval * (counterIntensity / 100)
      const newValue = getHashComputedCounterValue(
        hash,
        prevValue,
        baseIntensity,
        maxPerCounter,
        minPossible
      )
      // total += newValue
      counterValues[counterName] = newValue
    }

    // Ouptut old retrospect counter style?
    // output.push({
    //   timestamp: tick,
    //   values: counterValues,
    //   value: total
    // })\

    // "Flat" style timeseries data
    output.push({
      [timestampKey]: tick,
      ...counterValues,
    })
  }

  return output
}
